<template>
  <div>
    <div id="registrationArchive" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-md" role="document">
        <div
          class="modal-content custom-archive-modal-class"
          :class="!archivedFlag ? 'modal-content-archive' : 'modal-content-unarchive'"
        >
          <div class="modal-header">
            <section>
              <div class="col-xs-12 p-18 d-flex align-items-center justify-content-between header-wrapper">
                <div class="modal-header-title fw-600 font-20">
                  <div v-if="!archivedFlag">{{ $t('archiveCertificate') }}</div>
                  <div v-else-if="archivedFlag">{{ $t('unarchiveCertificate') }}</div>
                </div>
                <img
                  class="pr-5 cursor-pointer"
                  src="/static/images/icons/emergo_modal_close.svg"
                  @click="closeModal"
                />
              </div>
            </section>
          </div>
          <div class="modal-body p-0">
            <div class="row">
              <div class="col-xs-12">
                <div class="col-xs-12 pl-32 pr-32">
                  <div
                    class="col-xs-12 p-0"
                    v-if="this.validateSFManagedReecordFlag && (roleId === 8 || roleId === 9)"
                    style="color: #a94442 !important;"
                  >
                    Records indicated in red are Emergo managed and cannot be archived.
                  </div>
                  <template v-if="!archivedFlag">
                    <section>
                      <div class="col-xs-12 p-0 font-18 archive-text mb-24">
                        {{ $t('youAreAboutTo') }} {{ $t('Archive') }} {{ $t('the-record') }}(s) {{ $t('archive-msg1') }}
                        {{ $t('archive-msg2') }}
                      </div>
                      <div class="col-xs-12 p-0 fw-600 font-16 archive-text mb-24">
                        {{ $t('pleaseAddReason') }}
                      </div>
                      <div class="col-xs-12 pl-8 pr-8 pb-20">
                        <table class="table table-responsive emergo-table">
                          <thead>
                            <tr>
                              <th>
                                {{ $t('productName') }}
                              </th>
                              <th v-if="!archivedFlag">
                                {{ $t('reasonForArchiving') }}
                              </th>
                            </tr>
                          </thead>
                          <tbody ref="tbodyBoxDelete">
                            <tr
                              v-for="(row, index) in archieveData"
                              :key="index"
                              v-bind:class="{ 'highlighted-row-error': validateSFManagedReecords(index) }"
                            >
                              <td>
                                {{ row['Product'] }}
                              </td>
                              <td v-if="!archivedFlag">
                                <autocomplete class="archiving-auto"
                                  :suggestions="selectedArchiveReason"
                                  :placeholder="$t('reasonForArchiving')"
                                  v-model="row['archivingReasonName']"
                                ></autocomplete>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </section>
                  </template>
                  <template v-if="archivedFlag">
                    <section>
                      <div class="col-xs-12 p-0 font-18 archive-text mb-16">
                        {{ $t('youAreAboutTo') }} {{ $t('un-archive') }} {{ $t('the-record') }}(s)
                        {{ $t('unarchive-data') }}
                      </div>
                      <div class="col-xs-12 p-0 fw-600 font-16 archive-text un-archive-confirmation">
                        {{ $t('unArchiveMsg') }}
                      </div>
                    </section>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <section>
              <div class="col-xs-12 p-0 d-flex justify-content-end col-gap-16">
                <button
                  type="button"
                  class="btn emergo-btn emergo-secondary-button"
                  data-dismiss="modal"
                  @click="cancelDelete"
                >
                  {{ $t('noCancel') }}
                </button>

                <button
                  type="button"
                  class="btn emergo-btn emergo-primary-button"
                  @click="validateRecordsLimit"
                  :disabled="loaderStatus"
                >
                  {{ $t('Yes') }},
                  <span v-if="!archivedFlag">{{ $t('Archive') }}</span>
                  <span v-else>{{ $t('proceed') }}</span>
                </button>
              </div>
            </section>
          </div>
        </div>
        <loader :loadingStatus="loaderStatus"></loader>
      </div>
    </div>
    <generic-popup
      v-if="showGenericePopup"
      :genericPopupId="genericPopupId"
      :genericHeader="'Record Limit'"
      :genericBody="'upgradeRecords'"
      :max_number="max_registrations"
      @emitUpgradeRecords="upgradeRecords"
    ></generic-popup>
  </div>
</template>

<script>
import $ from 'jquery';
import cloneDeep from 'clone-deep';
import moment from 'moment';
import Loader from '../UIComponents/Loader.vue';
import Autocomplete from '../UIComponents/AutoComplete.vue';
import GenericPopup from '../UIComponents/GenericPopup.vue';
import {
  getArchivingReasons,
  archiveMultiRegistrationDetails
} from '../../apis/registrations';
import { getAddonDetails } from '../../apis/psm';
import EventBus from '../../utils/event-bus';

export default {
  components: {
    Loader,
    Autocomplete,
    GenericPopup
  },
  props: {
    data: Array,
    archivedFlag: Boolean,
    archiveReasonsList: Array,
    selectedArchiveReason: Array,
    roleId: Number
  },
  data() {
    return {
      max_registrations: 0,
      no_of_records: 0,
      showGenericePopup: false,
      loaderStatus: false,
      errors: [],
      archieveData: [],
      validateSFManagedReecordFlag: false,
      recordAddonService: {},
      teamAddonService: {},
      upgradeService: {},
      genericPopupId: 'genericPopupRecord',
    };
  },
  watch: {
    data() {
      this.archieveData = cloneDeep(this.data.map((record) => ({ ...record, archivingReasonName: '' })));
    }
  },
  mounted() {
    $('#registrationArchive').on('show.bs.modal', () => {
      this.showGenericePopup = true;
    });
  },
  methods: {
    clearNotifcations() {
      this.$notify({
        clear: true,
        group: 'custom-notification'
      });
    },

    upgradeRecords() {
      EventBus.$emit('upgradeRecords', {
        recordAddonService: this.recordAddonService,
        teamAddonService: this.teamAddonService
      });
    },
    async validateRecordsSize() {
      const addonAccountDetails = await getAddonDetails(JSON.parse(localStorage.getItem('userData')).account_id);
      this.recordAddonService = addonAccountDetails.find((each) => each.units === 'RECORDS');
      this.teamAddonService = addonAccountDetails.find((each) => each.units === 'USERS');
      if (this.recordAddonService) {
        if (
          this.recordAddonService.total_limit >= this.recordAddonService.default_limit &&
          this.recordAddonService.is_active &&
          moment()
            .utc()
            .format('YYYY-MM-DD HH:mm:ss') < this.recordAddonService.valid_until &&
          moment()
            .utc()
            .format('YYYY-MM-DD HH:mm:ss') >= this.recordAddonService.valid_from
        ) {
          this.max_registrations = this.recordAddonService.total_limit;
        } else if (
          this.recordAddonService.total_limit >= this.recordAddonService.default_limit &&
          this.recordAddonService.is_active &&
          moment()
            .utc()
            .format('YYYY-MM-DD HH:mm:ss') > this.recordAddonService.valid_until &&
          moment()
            .utc()
            .format('YYYY-MM-DD HH:mm:ss') >= this.recordAddonService.valid_from
        ) {
          this.max_registrations = this.recordAddonService.default_limit;
        }
        this.no_of_records = this.recordAddonService.current_utilization;
      }
    },
    async validateRecordsLimit() {
      this.loaderStatus = true;
      this.archiveRegistrations();
    },
    closeModal() {
      $('#registrationArchive').modal('hide');
    },
    cancelDelete() {
      this.validateSFManagedReecordFlag = false;
      this.$emit('loadRegistrationDataAfterCancel', this.data);
      this.archieveData = this.data;
    },
    validateSFManagedReecords(index) {
      if (this.data[index].salesForceManaged !== 'no' && (this.roleId === 8 || this.roleId === 9)) {
        this.validateSFManagedReecordFlag = true;
        return 'highlighted-row-error';
      }
      return '';
    },
    querySearch(queryString, cb) {
      const links = this.archiveReasonsList;
      const results = queryString ? links.filter(this.createFilter(queryString)) : links;
      // call callback function to return suggestions
      cb(results);
    },
    createFilter(queryString) {
      return (link) => link.value.indexOf(queryString.toLowerCase()) === 0;
    },
    async getArchiveReason() {
      const response = await getArchivingReasons();
      response.forEach((data) => {
        this.selectedArchiveReason.push(data.reason);
        this.archiveReasonsList.push(data.reason);
      });
    },
    async archiveRegistrations() {
      this.loaderStatus = true;
      const records = [];
      this.archieveData.forEach((row) => {
        const obj = {
          registrationId: row.registrationId
        };
        if (row.archivingReasonName && row.archivingReasonName.replace(/\s+/g, '')) {
          obj.archiveReasonName = row.archivingReasonName.replace(/\s+/g, '');
        }
        if (this.roleId === 8 || this.roleId === 9) {
          if (row.salesForceManaged === 'no') {
            records.push(obj);
          }
        } else {
          records.push(obj);
        }
      });
      if (records.length === 0) {
        this.clearNotifcations();
        this.$notify({
          type: 'error',
          title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
          text: 'No records archived!',
          group: 'custom-notification'
        });
        this.loaderStatus = false;
        $('#registrationArchive').modal('hide');
        return;
      }
      const option = this.archivedFlag ? 0 : 1;
      const response = await archiveMultiRegistrationDetails(option, records);
      if (response) {
        if (option === 0) {
          this.clearNotifcations();
          this.$notify({
            type: 'success',
            title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
            text:
              this.$i18n.locale === 'Portuguese'
                ? 'Registro(s) desarquivado(s) com sucesso!'
                : 'Registration(s) un-archived successfully!',
            group: 'custom-notification'
          });
        } else {
          this.clearNotifcations();
          this.$notify({
            type: 'success',
            title: this.$i18n.locale === 'Portuguese' ? 'Sucesso' : 'Success',
            text:
              this.$i18n.locale === 'Portuguese'
                ? 'Registro(s) arquivado(s) com sucesso!'
                : 'Registration(s) archived successfully!',
            group: 'custom-notification'
          });
        }
        this.loaderStatus = false;
        this.validateSFManagedReecordFlag = true;
        $('#registrationArchive').modal('hide');
        this.$emit('loadRegistrationDataafterArchive', response);
      } else {
        this.loaderStatus = false;
        if (option === 1) {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: 'Unable to archive registration(s)!',
            group: 'custom-notification'
          });
        } else {
          this.clearNotifcations();
          this.$notify({
            type: 'error',
            title: this.$i18n.locale === 'Portuguese' ? 'Erro' : 'Error',
            text: 'Unable to un-archive registration(s)!',
            group: 'custom-notification'
          });
        }
      }
    }
  }
};
</script>
<style>
/* .table-scroll .auto-complete ul {
  overflow-x: unset !important;
}
.table-scroll .auto-complete.open:after {
  width: 92%;
}
.table-scroll .dropdown.icon {
  top: 11px !important;
} */
</style>
<style scoped>

::v-deep .auto-complete .form-control {
  height: 36px;
}

.emergo-table.table tbody td {
  padding: 8px 14px 8px 14px !important;
}
.modal-content-archive {
  width: 700px;
}
.pl-32 {
  padding-left: 32px;
}
.pr-32 {
  padding-right: 32px;
}

.pl-8 {
  padding-left: 8px;
}

.pr-8 {
  padding-right: 8px;
}

.archive-text {
  line-height: 25px;
  color: #333333;
  /* margin-bottom: 24px; */
  font-weight: 400;
}

.mb-24 {
  margin-bottom: 24px;
}

.archive-text.fw-600 {
  font-weight: 600;
}
.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 1;
}
.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #b4b4b4;
}
.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #b4b4b4;
}
/* .border-bottom-line {
  border-bottom: 1px solid rgba(52, 17, 126, 0.1);
} */
.dotted-line {
  margin: 3px 29px 0px 17px;
  border-top: 1px dashed rgba(52, 17, 126, 0.6);
}
/* .table > thead:first-child > tr:first-child > th {
  font-weight: 400;
  color: #01518a;
  font-size: 14px;
  line-height: 19px;
} */
.pl-33 {
  padding-left: 33px;
}
.archive-record {
  font-size: 24px;
  font-weight: 300;
  color: #333333;
  line-height: 33px;
}
.archive-data {
  font-size: 16px;
  font-weight: 300;
  color: #333333;
  line-height: 22px;
  padding-top: 8px;
}
.pt-15 {
  padding-top: 15px;
}
.archive-reason {
  font-weight: 700;
  color: #333333;
  font-size: 18px;
  line-height: 25px;
  padding-top: 21px;
  padding-bottom: 34px;
}
.icon-close {
  color: #333333 !important;
  float: right;
  cursor: pointer;
}
/* .modal-content-archive {
  height: 600px;
  max-height: 90vh;
} */
.modal-content-unarchive {
  height: auto;
  width: 500px;
}

.modal-open .modal {
  overflow-y: hidden;
}
.container-fluid {
  padding-right: 3px;
}
#registrationArchive tbody::-webkit-scrollbar {
  width: 6px;
}
#registrationArchive tbody::-webkit-scrollbar-thumb {
  background: #d9d9d9;
  border-top-left-radius: 18px;
  border-bottom-left-radius: 18px;
  outline: none;
}
#registrationArchive tbody::-webkit-scrollbar-track {
  box-shadow: none;
}
.custom-archive-modal-class .modal-header {
  border-bottom: none;
  background-color: #ffffff;
  padding: 0px;
  border-radius: 8px;
  color: #1a1a1a;
}
.custom-archive-modal-class .modal-footer {
  background-color: #fafaf9;
  border-top: none;
  border-radius: 8px;
  padding: 16px;
}

#registrationArchive tbody {
  height: 20vh;
  overflow-y: auto;
}
/* .table-bordered-outside {
  border: none;
} */
/* .table thead {
  background-color: #ffffff;
}
.table > thead > tr > th {
  border-bottom: none;
} */
/* .table > tbody > tr > td {
  padding-left: 7px !important;
  padding-bottom: 14px !important;
  padding-top: 13px !important;
  color: #333333;
  font-size: 14px;
}
.table > tbody > tr:last-child {
  border-bottom: none;
} */
/* @media (max-width: 991px) {
  .table-scroll .table {
    min-width: 870px;
  }
} */
/* .table-scroll {
  overflow: auto;
  margin: 0px 0px 0px;
  padding: 0;
  height: auto;
}

#registrationArchive tbody {
  height: 27vh;
  padding-right: 32px;
  padding-left: 26px;
}
.table-scroll .table {
  border-top: none;
}
.table-scroll .table thead {
  border-top: none;
  position: sticky;
  top: 0;
  z-index: 1;
} */

.modal-header-title {
  line-height: 27px;
  color: #1a1a1a;
}

.header-wrapper {
  border-bottom: 1px solid #d3d3d3;
  margin-bottom: 24px;
}

.un-archive-confirmation {
  margin-bottom: 66px;
}

@media screen and (min-width: 768px) {
  .modal-dialog {
    width: unset;
  }
}

.search-ul .active a {
  background: rgba(0, 0, 0, 0.05);
  color: #333;
}

</style>
